module.exports = __webpack_public_path__ + "/images/shop/caris-cockpit/nat_code2.jpg";